export default __webpack_public_path__ + "static/media/place-7.99faec09.jpg";